<template>
  <div class="welcome pb-0 mb-0 white" style="display: flex; flexDirection: column; height: 100%">
		<v-layout md-12 class="white" row justify-space-between align-center style="margin-bottom: 30px; margin-top: 20px;">
			<div class="column" style="justify-content: center; align-items: center;">
    		<h1 class="point8 py-3 text-xs-center" style="font-weight: bold;">Welcome to ME/CFS Group Canterbury</h1>
				<div style="justify-content: center">
					<p class="my-2 mx-4 text-xs-center point6 blueText">Our aim is to support and empower people with ME/CFS, and their whānau, in Canterbury.</p>
				</div>
				<div style="margin-top: 35px; align-self: flex-start;">
					<p class="mx-4 text-xs-left point6">We do this by developing the ME/CFS community, sharing evidence-informed practice and advocating for better awareness and care.
					Our services include monthly group meetings, newsletters, home visits by our Community Facilitator, advocacy, access to resources and education.</p>
				</div>
			</div>
		</v-layout>

		<hr style="color: #BBB; margin-bottom: 20px;">

		<MonthlyMeeting></MonthlyMeeting>
		<BoxLinks></BoxLinks>
		<Sponsors></Sponsors>
  </div>
</template>

<script>

import MonthlyMeeting from '../components/MonthlyMeeting'
import BoxLinks from '../components/BoxLinks'
import Sponsors from '../components/Sponsors'

export default {
  components: {
	MonthlyMeeting,
    BoxLinks,
    Sponsors,
  },
  mounted() {
    if (this.$route.name === "contact") {
		window.scrollTo(0, document.body.scrollHeight);
	}
  }
}
</script>
